import React, { useMemo, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';

import { Tile } from './tile';

function RelatedProducts({ product: { title: productTitle } }) {
  const { allShopifyProduct } = useStaticQuery(graphql`
    {
      allShopifyProduct(
        sort: { fields: updatedAt, order: DESC }
        filter: { availableForSale: { eq: true } }
      ) {
        nodes {
          handle
          images {
            originalSrc
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          productType
          tags
          title
          updatedAt
          variants {
            shopifyId
          }
        }
      }
    }
  `);
  const { nodes: products } = allShopifyProduct;
  const [relatedProducts, setRelatedProducts] = useState([]);

  useMemo(() => {
    const results = [];

    const searchTerms = Object.values(productTitle.split(' ')).map(
      (value) => value
    );

    products.map((prod) => {
      for (let i = 0; i < searchTerms.length; i += 1) {
        if (
          prod.title.toLowerCase().indexOf(searchTerms[i].toLowerCase()) !== -1
        )
          if (!results.includes(prod) && prod.title !== productTitle)
            results.push(prod);
      }
      return setRelatedProducts(results);
    });
  }, [productTitle, products]);

  if (relatedProducts.length < 1) return null;
  return (
    <article className="w-full max-w-xs px-4 mx-auto sm:max-w-2xl lg:max-w-7xl sm:px-6 lg:px-8">
      <h2 className="text-3xl font-medium tracking-wider uppercase">
        We think you'll love these:
      </h2>
      <ul className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {relatedProducts.slice(0, 4).map((prod) => (
          <li key={prod.handle}>
            <Tile
              title={prod.title}
              slug={`/products/${prod.handle}/`}
              price={Number(prod.priceRange.minVariantPrice.amount)}
              image={prod.images[0]}
            />
          </li>
        ))}
      </ul>
    </article>
  );
}

RelatedProducts.propTypes = {
  product: PropTypes.object,
};

export { RelatedProducts };
